import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=b2a960da&scoped=true&"
import script from "./ContactDetails.vue?vue&type=script&lang=js&"
export * from "./ContactDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetails.vue?vue&type=style&index=0&id=b2a960da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a960da",
  null
  
)

export default component.exports